module.exports = __webpack_public_path__ + "img/07.144f5dcb.png";